import { render, staticRenderFns } from "./SubtotalsTable.vue?vue&type=template&id=289013ce&scoped=true"
import script from "./SubtotalsTable.vue?vue&type=script&lang=js"
export * from "./SubtotalsTable.vue?vue&type=script&lang=js"
import style0 from "./SubtotalsTable.vue?vue&type=style&index=0&id=289013ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289013ce",
  null
  
)

export default component.exports